import React from 'react';

import CN from 'components/experiment/hooks/HooksPage.module.scss';
import Button from 'components/form/Button.component';
import S from 'constants/string.const';
import useAfn from 'hooks/useAfn.hook';
import delayed from 'utils/functions/delayed.util';
import logger from 'utils/logger.util';

const L = logger('AsyncFunctionExample');

const delayedResolve = (ms, result) => new Promise((resolve) => void delayed(ms, () => resolve(result)));
const delayedReject = (ms, reason) => new Promise((resolve, reject) => void delayed(ms, () => reject(reason)));

const AsyncFunctionExample = () => {
  const [{ value, error, isLoading, isLoaded }, handleClick] = useAfn(async () => {
    const MS = 1000;
    const r = Math.random();

    L.debug('handleClick()', 'r:', r);

    const w1 = await (r >= 0.3 ? delayedResolve(MS, 'Hello') : delayedReject(MS, 'Um...'));
    const w2 = await (r >= 0.6 ? delayedResolve(MS, 'World') : delayedReject(MS, 'Oh, no!'));

    return `${w1} ${w2}`;
  });

  L.debug('()', { value, error, isLoading, isLoaded });

  return (
    <div data-bem="AsyncFunctionExample" className={CN.col}>
      <div className={CN.row}>
        <Button onClick={handleClick}>Do Async</Button>
        <p>
          value:{S.nbsp}
          {String(value)}
          <br />
          error:{S.nbsp}
          {String(error)}
          <br />
          isLoading:{S.nbsp}
          {String(isLoading)}
          <br />
          isLoaded:{S.nbsp}
          {String(isLoaded)}
          <br />
        </p>
      </div>
    </div>
  );
};

export default AsyncFunctionExample;
